export default __webpack_public_path__ + "static/media/np.0f535d07.svg";